import fetch from '@/axios/promise';
import  {FLYBACK_URL} from  '@/config/constant';
import qs from 'qs';

// 获取列表数据
export function page(query) {
  return invoke(query,'/getFlybackApplyPage','POST');
}

// 获取flyback申请数量
export function getFlybackApplyCount(query){
  return invoke(query,'/getFlybackApplyCount','POST');
}

// 获取flyback申请数据
export function detailListData(query) {
  return invoke(query,'/getFlybackApplyList','POST');
}

// 获取flyback月份的申请数据
export function monthListData(query) {
  return invoke(query,'/getFbListByMonth','POST');
}

// 获取flyback申请单个数据
export function detailData(query) {
  return invoke(query,'/getFlybackApplyData','POST');
}

// 保存flyback申请数据
export function saveData(data){
  return invoke2(data,'/saveFlybackApplyData','POST');
}

// flyback申请流程提交
export function apprProcSubmit(data) {
  return invoke(data,'/apprProcSubmit','POST');
}

// 审批flyback申请，数据处理
export function approveDeal(data){
  return invoke(data,'/approveFlybackApply','POST');
}

// 删除flyback申请数据
export function delDetailData(query) {
  return invoke(query,'/delFlybackApplyData','POST');
}

// 获取该项目下申请人以前申请过的次数
export function getProjFbApplyCount(query) {
  return invoke(query,'/getProjFbApplyCount','POST');
}

function invoke(query,url,method){
  return fetch({
    url: FLYBACK_URL+url,
    method: method,
    params: query
  });
}

// 调用
// data 参数， 需要传递 format data 类型，或者后台 参数 添加 @RequestBody接收
//eg: let postData= new URLSearchParams()
//postData.append('param1',  value1)
//postData.append('param2',  value1)

function invoke2(data,url,method){
  // 需要转下
  data = qs.stringify(data);
  return fetch({
    url: FLYBACK_URL+url,
    method: method,
    data: data
  });
}


// WEBPACK FOOTER //
// ./src/api/flyback/flyback.js